package cc.easyandroid.extensions_compose.mvi

import cc.easyandroid.easycompose.mvi.store.Bootstrapper
import cc.easyandroid.easycompose.mvi.utils.internal.atomic
import cc.easyandroid.easycompose.mvi.utils.internal.initialize
import cc.easyandroid.easycompose.mvi.utils.internal.requireValue
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.cancel
import kotlin.coroutines.CoroutineContext

/**
 * Creates coroutine [Bootstrapper] using the provided [handler].
 *
 * @param mainContext main [CoroutineContext] to be used by default when launching coroutines, default value is [Dispatchers.Main].
 * @param handler invoked when the [Bootstrapper] is invoked by the [Store][cc.easyandroid.easycompose.mvi.store.Store].
 */
fun <Action : Any> coroutineBootstrapper(
    mainContext: CoroutineContext = Dispatchers.Main,
    handler: CoroutineBootstrapperScope<Action>.() -> Unit,
): Bootstrapper<Action> =
    object : AbstractBootstrapper<Action>(scope = CoroutineScope(mainContext)) {
        override fun invoke() {
            handler()
        }
    }

private abstract class AbstractBootstrapper<Action : Any>(
    private val scope: CoroutineScope,
) : Bootstrapper<Action>, CoroutineBootstrapperScope<Action>, CoroutineScope by scope {

    private val actionConsumer = atomic<(Action) -> Unit>()

    override fun init(actionConsumer: (Action) -> Unit) {
        this.actionConsumer.initialize(actionConsumer)
    }

    override fun dispatch(action: Action) {
        actionConsumer.requireValue().invoke(action)
    }

    override fun dispose() {
        scope.cancel()
    }
}
